import { render, staticRenderFns } from "./groupForm.vue?vue&type=template&id=f71f6640&%23default=true&"
import script from "./groupForm.vue?vue&type=script&lang=js&"
export * from "./groupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports